<template>
  <div class="vue-wrapper-full" style="flex-wrap: wrap">
    <div class="grid-x toolbar small">
      <div class="cell auto">
        <span class="search-filter-info no-wrap">
          <ul>
            <li><strong>Antall objekter:</strong> {{totals.total_objects ? totals.total_objects : 0 | thousands}}</li>
            <li><strong>Vurd. lav sum:</strong> {{(totals.total_vurderingspris2 ? totals.total_vurderingspris2 : 0) | thousands}} kr</li>
            <li><strong>Vurd. høy sum:</strong> {{(totals.total_vurderingspris1 ? totals.total_vurderingspris1 : 0) | thousands}} kr</li>
            <li><strong>Tilslag, samlet sum:</strong> {{(totals.total_salgspris ? totals.total_salgspris : 0) | thousands}} kr</li>
            <li><strong>Selger salær, samlet sum:</strong> {{(totals.total_tax ? totals.total_tax : 0) | thousands}} kr</li>
            <li><strong>Bud verdier nå:</strong> {{(totals.total_bids_value ? totals.total_bids_value : 0) | thousands}} kr</li>
            <li>
              <strong>Antall obj. med bud:</strong>
              <span v-if="totals && totals.total_bids_objects && totals.total_objects">
                {{totals.total_bids_objects}} / {{totals.total_objects}}
              </span>
              <span v-else>
                0 / 0
              </span>
            </li>
          </ul>
        </span>
      </div>
    </div>

    <div class="content-container flex-row">
      <!-- Sidebar -->
      <div class="sidebar white left fixed" :class="sidebarVisibleClass">
        <div class="fixed-container">
          <a href="javascript:;" @click="toggleSidebar" class="sidebar-minimized-button table-overlay-close">
            <span class="button-arrow"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-small"></use></svg></span>
            <span class="glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg></span>
          </a>

          <div class="sidebar-content-container small-padding custom-scrollbar">
            <TheSidebarObjectModule
              v-if="selected.Objektid"
              v-on:prev="onPrev"
              v-on:next="onNext"
              v-on:on-save="onSave"
              :objekt="selected"
            />
            <TheSidebarObjectLinks v-if="selected.Objektid" :objekt="selected" />
            <TheSidebarColorCodes/>
          </div>
        </div>
      </div>
      <!-- // Sidebar -->

      <!-- Objekt list -->
      <div class="content-container flex-row">
        <div class="content-container flex-column">
          <div id="scroll-container" class="content-container gray flex-row content-x-scroll content-y-scroll small-toolbar">
            <!-- Pagination -->
            <div class="pagination-loader-container">
              <div class="pagination-loader">
                <span class="results">Viser <strong>{{list.length | thousands}}</strong> av {{hits | thousands}} treff</span>

                <a href="javascript:;" v-if="loading" class="button primary tiny loading">Last flere <span class="loader-spinner"></span></a>
                <a href="javascript:;" v-else-if="list.length < 1" class="button primary tiny disabled">Last flere</a>
                <a href="javascript:;" v-else-if="list.length < hits" @click="more()" class="button primary tiny">Last flere</a>
                <a href="javascript:;" v-else-if="list.length >= hits" class="button primary tiny disabled">Last flere</a>

                <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
              </div>
            </div>
            <!-- // Pagination -->

            <table class="large fixed sortable clickable sticky-table-header compressed color-rows" :class="[selectedImageSize.key || 'c-image-small']" style="height: 0">
              <thead>
                <tr class="header">
                  <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                    {{col.name}}

                    <span id="sorttable_sortfwdind" v-if="(sort.startsWith(col.sortKey + ' ') || /^Objekt__Katalognr (ASC|DESC), Objekt__Kontraktnr (ASC|DESC), Objekt__Lopenr (ASC|DESC)$/.test(sort) && col.sortKey === 'Objekt__Katalognr') && dir === 'ASC'" class="sort-on">&nbsp;</span>
                    <span id="sorttable_sortrevind" v-else-if="(sort.startsWith(col.sortKey + ' ') || /^Objekt__Katalognr (ASC|DESC), Objekt__Kontraktnr (ASC|DESC), Objekt__Lopenr (ASC|DESC)$/.test(sort) && col.sortKey === 'Objekt__Katalognr') && dir === 'DESC'" class="sort-on">&nbsp;</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, trindex) in list" :key="trindex" :class="[hasSelectedObjekt(row.Objektid) ? 'color-row-active' : '', row.cls]" @click="setSelectedObjekt(row.Objektid)">
                  <template v-for="(col, tdindex) in row.row">
                    <td v-if="col.image" :key="trindex + '.' + tdindex" :class="col.class">
                      <img v-if="selectedImageSize.key !== 'c-image-none'" :class="{'hi-trigger': col.large}" :src="col.value" :data-hi-src-full="col.large" data-hi-size="large" />
                    </td>
                    <td v-else-if="col.tooltip" :key="trindex + '.' + tdindex" :class="col.class" v-tippy :content="col.tooltip">{{col.value}}</td>
                    <td v-else :key="trindex + '.' + tdindex" :class="col.class" >{{col.value}}</td>
                  </template>
                </tr>
                <template v-if="searchDone">
                  <tr v-if="list.length < 1"><td colspan="30" style="text-align: left;">Fant ingen objekter...</td></tr>
                </template>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <!-- // Objekt list -->
    </div>
  </div>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import InstillingerService from '@/services/InstillingerService'
import TheSidebarObjectModule from './TheSidebarObjectModule'
import TheSidebarObjectLinks from './TheSidebarObjectLinks'
import TheSidebarColorCodes from './TheSidebarColorCodes'
import bus from '@/plugins/event-bus'
import Papa from 'papaparse'
import moment from 'moment'
import fileDownload from 'js-file-download'

const CalcLagerLeie = (obj, vm) => {
  if (!obj.Lagerleiedato) {
    return 0
  }

  if (obj.Lev_dato) {
    // Get price from bilag
    // const lines = vm._.get(obj, 'oppgjorsbilag.bilagslinje')

    // if (lines) {
    //   const line = lines.find(i => i.Varenr === 'LLUKE')

    //   if (line) {
    //     return line.Beloptotal
    //   }
    // }

    return 0
  }

  const today = moment().format('YYYY-MM-DD')
  const ldato = moment(moment(obj.Lagerleiedato).format('YYYY-MM-DD'))
  const diff = ldato.diff(today)

  // Today or less than today's date = Lagerleie has begun
  if (diff <= 0) {
    const totd = Math.abs(moment.duration(diff).as('days'))
    const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)
    // weeks from object
    const weeks = obj.lagerleie_weeks ? obj.lagerleie_weeks : totw

    // Resolve price based on this object's department
    const config = LAGERLEIE_VARE_CONFIG.find(c => c.avdelingsid === obj.Avdelingsid) ||
                   LAGERLEIE_VARE_CONFIG.find(c => c.avdelingsid === null)

    const price = config ? (vm.lagerLeiePrices[config.vareId] || 0) : 0

    return weeks * price
  }

  return 0
}

const CalcColorCode = (obj, vm) => {
  // Avtalt retur
  if (obj.auksjon && obj.auksjon.Auksjontype === 'R') {
    if (obj.Bet_dato) { // Retur - betalt
      return 'color-row-bg-blue'
    } else { // Retur - ubetalt
      return 'color-row-bg-blue color-row-text-red'
    }
  }

  // Usolgt
  if (!obj.Tilslagnr || parseInt(obj.Tilslagnr) === 950) {
    return 'color-row-text-gray'
  }

  // Med forbehold
  if (obj.Mfgs === 'M') {
    return 'color-row-bg-red'
  }

  // Solgt - ikke fakt.
  if (obj.Fakturert !== 'F') {
    return 'color-row-bg-yellow'
  }

  // Fakt. - ubetalt
  if (!obj.Bet_dato) {
    return 'color-row-bg-green color-row-text-red'
  }

  // Fakt. - betalt
  return 'color-row-bg-green'
}

/**
 * Lagerleie prices per Avdelingsid.
 * - key: Avdelingsid (number), or null as default/fallback
 * - vareId: ID from the vare table
 */
const LAGERLEIE_VARE_CONFIG = [
  { avdelingsid: 2, vareId: 79 }, // Vin
  { avdelingsid: null, vareId: 49 } // Default (alle andre avdelinger)
]

export default {
  name: 'Tilslagsskjermbilde',
  components: {
    TheSidebarObjectModule,
    TheSidebarObjectLinks,
    TheSidebarColorCodes
  },
  data () {
    return {
      showSidebar: false,
      loading: false,
      code: null,
      totals: {
        total_objects: 0,
        total_vurderingspris2: 0,
        total_vurderingspris1: 0,
        total_salgspris: 0,
        total_tax: 0,
        total_bids_value: 0,
        total_bids_objects: 0
      },
      hits: 0,
      page: 1,
      pages: 1,
      last: null,
      info: {},
      list: [],
      current: [],
      selected: {},
      searchDone: false,
      sort: `Objekt__Katalognr ASC, Objekt__Kontraktnr ASC, Objekt__Lopenr ASC`,
      dir: 'ASC',
      /** Map of vareId → price, populated by fetchSettings */
      lagerLeiePrices: {}
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Tilslagsskjermbilde'
    },
    columns: function () {
      // Should handle sorting
      const cols = this.$store.getters['tilslagsskjermbilde/columns']

      return cols.filter(c => c.selected)
    },
    columnKeys: function () {
      return this.columns.map((col) => {
        return col.key
      })
    },
    selectedImageSize: function () {
      return this.$store.getters['tilslagsskjermbilde/selectedImageSize']
    },
    sidebarVisibleClass: function () {
      return this.showSidebar ? 'minimizable' : 'minimized'
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')

    this.showSidebar = localStorage.getItem('tilslagsskjermbilde-sidebar')

    bus.$off('tilslagsskjermbilde-start')
    bus.$off('tilslagsskjermbilde-after-column-update')
    bus.$off('tilslagsskjermbilde-export')
    bus.$on('tilslagsskjermbilde-export', () => this.onExportResults())

    this.fetchSettings()
  },
  mounted () {
    bus.$on('tilslagsskjermbilde-start', (data) => this.onSearch(data))
    bus.$on('tilslagsskjermbilde-after-column-update', () => this.onAfterColumnUpdate())
  },
  methods: {
    fetchSettings: function () {
      // Fetch lagerleie price for each configured vare in parallel.
      const uniqueVareIds = [...new Set(LAGERLEIE_VARE_CONFIG.map(c => c.vareId))]

      Promise.all(
        uniqueVareIds.map(vareId =>
          InstillingerService('vare').view(vareId)
            .then(response => ({ vareId, price: Number(response.data.Pris) }))
        )
      )
        .then(results => {
          results.forEach(({ vareId, price }) => {
            this.$set(this.lagerLeiePrices, vareId, price)
          })
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
    },
    onSave: function (data) {
      // Update list and go to next
      const cindex = this.current.findIndex(o => o.Objektid === data.Objektid)
      if (cindex !== -1) {
        this.$set(this.current, cindex, data)

        this.rearrange(this.current)
          .then((parsed) => {
            this.list = parsed.list
            this.last = parsed.last
            this.info = parsed.info

            this.onNext()
          })
      } else {
        this.onNext()
      }
    },
    onPrev: function () {
      if (this.selected.Objektid) {
        try {
          const current = this.list.findIndex(i => i.Objektid === this.selected.Objektid)

          if (current > 0) {
            const prev = this.list[current - 1]

            this.setSelectedObjekt(prev.Objektid)
          } else {
            this.setSelectedObjekt(null)
          }
        } catch (e) {
          console.log('Failed to go to prev item')
          console.log(e)
        }
      }
    },
    onNext: function () {
      if (this.selected.Objektid) {
        try {
          const current = this.list.findIndex(i => i.Objektid === this.selected.Objektid)

          if (current < this.list.length - 1) {
            const next = this.list[current + 1]

            this.setSelectedObjekt(next.Objektid)
          } else {
            this.setSelectedObjekt(null)
          }
        } catch (e) {
          console.log('Failed to go to prev item')
          console.log(e)
        }
      }
    },
    setSelectedObjekt: function (Objektid) {
      if (Objektid !== null && (!this.selected.Objektid || this.selected.Objektid !== Objektid)) {
        this.selected = this.info.hasOwnProperty(Objektid) ? this.info[Objektid] : null
      } else {
        this.selected = {}
      }
    },
    hasSelectedObjekt: function (Objektid) {
      return this.selected.Objektid && this.selected.Objektid === Objektid
    },
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar

      if (this.showSidebar) {
        localStorage.setItem('tilslagsskjermbilde-sidebar', 1)
      } else {
        localStorage.removeItem('tilslagsskjermbilde-sidebar')
      }
    },
    scrollToTop: function () {
      window.jQuery('#scroll-container').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        // Not sortable
        return
      }

      const regexInitial = /^Objekt__Katalognr (ASC|DESC), Objekt__Kontraktnr (ASC|DESC), Objekt__Lopenr (ASC|DESC)$/
      const regexFields = /^(?!Objekt__Katalognr\b)\S+\s+(ASC|DESC)$/
      if (regexFields.test(this.sort) || (column.sortKey === 'Objekt__Katalognr' && regexInitial.test(this.sort))) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      if (column.sortKey === 'Objekt__Katalognr') {
        this.sort = `Objekt__Katalognr ${this.dir}, Objekt__Kontraktnr ${this.dir}, Objekt__Lopenr ${this.dir}`
      } else {
        this.sort = `${column.sortKey} ${this.dir}`
      }

      this.page = 1
      this.search()
    },
    more () {
      if (this.page < this.pages) {
        ++this.page

        this.search()
      }
    },
    onAfterColumnUpdate: function () {
      this.rearrange(this.current)
        .then((parsed) => {
          this.list = parsed.list
          this.last = parsed.last
          this.info = parsed.info
        })
    },
    onSearch: function (data) {
      this.code = data.code || null
      this.department = data.department
      this.from = data.from || null
      this.to = data.to || null

      let hasDepartment = !(this.department === null || this.department === '' || this.department === undefined)
      this.department = hasDepartment ? this.department : null

      if ((this.code && hasDepartment) || (!!this.from && !!this.to && hasDepartment)) {
        this.page = 1
        this.search()
      }
    },
    search: function () {
      if (this.loading) {
        return
      }

      if (this.page <= 1) {
        this.totals = {
          total_objects: 0,
          total_vurderingspris2: 0,
          total_vurderingspris1: 0,
          total_salgspris: 0,
          total_tax: 0,
          total_bids_value: 0,
          total_bids_objects: 0
        }
      }
      this.setSelectedObjekt(null)
      this.searchDone = false
      this.loading = true

      const post = {
        auction: this.code,
        department: this.department,
        from: this.from,
        to: this.to
      }

      const queryParams = {
        page: this.page || 1,
        sort: this.sort || `Objekt__Katalognr ${this.dir}, Objekt__Kontraktnr ${this.dir}, Objekt__Lopenr ${this.dir}`,
        direction: this.dir || 'ASC',
        limit: 500
      }

      ObjektService.getTilslagsList(post, queryParams)
        .then(response => {
          if (this.page <= 1) {
            this.info = {}

            this.current = response.data
          } else {
            this.current = [...this.current, ...response.data]
          }

          this.rearrange(response.data)
            .then((parsed) => {
              if (this.page <= 1) {
                this.list = parsed.list
                this.info = parsed.info
              } else {
                this.list = [...this.list, ...parsed.list]
                this.info = Object.assign({}, this.info, parsed.info)
              }

              this.last = parsed.last

              this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
              this.hits = response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
            })
        })
        .catch(error => {
          console.log('*** Search error')
          console.log(error)
        })
        .then(() => {
          this.loading = false
        })

      if (this.page <= 1) {
        ObjektService.getTilslagsTotals(post, queryParams)
          .then(response => {
            this.totals = response.data
          })
          .catch(error => {
            console.log('*** Search totals error')
            console.log(error)
          })
      }
    },
    rearrange: function (data) {
      return new Promise((resolve, reject) => {
        const defaultThumbnail = '/static/img/object.svg'

        const retval = {
          list: [],
          info: {},
          last: null
        }

        // Parse/format/sort data
        data.forEach(obj => {
          const row = []

          let clsTr = CalcColorCode(obj, this)

          this.columns.forEach(c => {
            let val = this._.get(obj, c.key, c.default)
            let clsTd = c.class

            // Calculate lagerleie sum
            if (c.key === 'Lagerleiesum') {
              val = CalcLagerLeie(obj, this)
            }

            // Calc salarbelop
            if (c.key === 'Salarbelop') {
              val = 0

              if (obj.Salgspris > 0 && obj.Salar > 0) {
                val = obj.Salgspris * obj.Salar / 100
              }
            }

            // Calc oppgjor belop + dato
            if (c.key === 'oppgjor_belop') {
              if (!obj.oppgjorsbilag) {
                val = obj.Oppbelop || c.default
              } else if (obj.Salgspris) {
                const lines = (this._.get(obj, 'oppgjorsbilag.bilagslinje') || []).filter(i => i.Varetype === 'V')
                let sum = obj.Salgspris

                if (lines) {
                  lines.forEach(l => {
                    sum -= Math.abs(l.Beloptotal || 0)
                  })
                }

                val = sum
              } else {
                val = c.default
              }
            }

            if (c.key === 'oppgjor_dato') {
              if (!obj.oppgjorsbilag) {
                val = obj.Oppgjorbetalt || c.default
              } else {
                val = obj.oppgjorsbilag.Forfallsdato || c.default
              }
            }

            // Get the correct bid amount in the old or new bid systems.
            if (c.key === 'current_nett_bud') {
              val = obj.current_nett_bud ? obj.current_nett_bud : obj.current_nett_bud_old || 0
            }

            // get the correct parse_name
            if (c.key === 'innlevav.parsed_name') {
              if (obj.innlevav.Bedrift) {
                val = obj.innlevav.FirmaNavn
              } else if (obj.innlevav.Fnavn || obj.innlevav.Enavn) {
                val = obj.innlevav.Fnavn + ' ' + obj.innlevav.Enavn
                val = val.trim()
              }
            }

            if (c.key === 'mottaker.parsed_name') {
              if (obj.mottaker.Bedrift) {
                val = obj.mottaker.FirmaNavn
              } else if (obj.mottaker.Fnavn || obj.mottaker.Enavn) {
                val = obj.mottaker.Fnavn + ' ' + obj.mottaker.Enavn
                val = val.trim()
              }
            }

            if (c.key === 'Auksjonsdato') {
              if (obj.Avdelingsid === 1 || obj.Avdelingsid === 2) { // Nettauksjon OR Vin
                val = obj.na_max_slutt
              } else if (obj.Avdelingsid === 0) { // Kunsthandel
                if (obj.na_max_slutt) {
                  val = obj.na_max_slutt
                } else {
                  val = obj.auksjon.Auksjon_dato
                }
              }
            }

            if (c.filter && val !== c.default) {
              switch (c.filter) {
                case 'date':
                  val = this.$options.filters.avantidate(val)
                  break
                case 'datetime':
                  val = this.$options.filters.avantidatetime(val)
                  break
                case 'integer':
                  val = this.$options.filters.thousands(val)
                  break
                case 'decimal':
                  val = this.$options.filters.thousandsFloat(val)
                  break
                case 'boolean':
                  val = val ? 'T' : 'F'
                  break
              }
            }

            // Parse and set images
            if (c.key === 'photo_thumb') {
              let thumb = this._.get(obj, 'photos.thumb') || null
              let large = this._.get(obj, 'photos.large') || null

              if (thumb && !thumb.startsWith('http')) {
                thumb = process.env.VUE_APP_AVANTI_API_URL + thumb
              }

              if (large && !large.startsWith('http')) {
                large = process.env.VUE_APP_AVANTI_API_URL + large
              }

              if (thumb) {
                row.push({ value: thumb, large: large, class: clsTd, tooltip: false, image: true })
              } else {
                row.push({ value: defaultThumbnail, large: null, class: clsTd, tooltip: false, image: true })
              }
            } else {
              row.push({ value: val, class: clsTd, tooltip: c.tooltip && val !== c.default ? this.$options.filters.truncate(val, 600) : false })
            }
          })

          retval.last = obj.Objektid
          retval.info[obj.Objektid] = obj
          retval.list.push({ Objektid: obj.Objektid, cls: clsTr, row: row })
        })

        resolve(retval)
      })
    },
    onExportResults: function () {
      if (!this.current || !this.current.length) {
        this.$helpers.showErrorAlert('Feil', 'Fant ingen objekter å eksportere')
        return
      }

      this.rearrange(this.current)
        .then((parsed) => {
          // All export data
          const data = []

          const includeImage = this.selectedImageSize.key !== 'c-image-none'

          // Add headings
          const item = []

          this.columns.forEach(c => {
            if (c.key !== 'photo_thumb' || includeImage) {
              item.push(c.name)
            }
          })
          data.push(item)

          // Add values
          parsed.list.forEach(r => {
            const item = []

            r.row.forEach(c => {
              if (!c.image) {
                item.push(c.value)
              } else if (includeImage) {
                item.push((c.large || c.thumb) || '-')
              }
            })

            data.push(item)
          })

          // Make csv and force download...
          const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
          const blob = new Blob([csv], {
            type: 'application/csvcharset=utf-8'
          })

          fileDownload(blob, 'tilslagsskjermbilde-' + moment().format('DDMMYYHms') + '.csv')
        })
        .catch(error => {
          console.log('*** CSV Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke eksportere')
        })
    }
  }
}
</script>
<style scoped>
  table td:focus {
    outline: none;
  }
  /* table tr.selected,
  table tr.selected:hover,
  table tr.selected:active,
  table tr.selected:focus {
    background: blue !important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/Tilslagsskjermbilde.vue